// eslint-disable-next-line no-restricted-imports
import { InputNumber } from "antd";

const ALLOWED_KEYS = new Set([
  "Backspace", "Delete", "Tab", "Escape", "Enter",
  "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown",
  "Home", "End", ".",
]);

function blockNonNumeric(e) {
  if (ALLOWED_KEYS.has(e.key)) return;
  if ((e.ctrlKey || e.metaKey) && "acvxz".includes(e.key.toLowerCase())) return;
  if (!/^\d$/.test(e.key)) e.preventDefault();
}

/**
 * Numeric input with thousand-separator formatting.
 *
 * Drop-in replacement for antd's InputNumber: forwards every prop, but supplies
 * default formatter/parser so callers don't have to repeat the regex pair.
 * The bound value stays a JS number — only the rendered text is formatted.
 *
 * Pass `formatter`/`parser` explicitly to override (e.g. percent inputs).
 */
function NumberInput({ formatter, parser, onKeyDown, ...rest }) {
  return (
    <InputNumber
      formatter={formatter || ((value) => {
        if (value === null || value === undefined || value === "") return "";
        const [intPart, decPart] = String(value).split(".");
        const withCommas = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return decPart !== undefined ? `${withCommas}.${decPart}` : withCommas;
      })}
      parser={parser || ((value) => (value || "").replace(/[^0-9.]/g, ""))}
      onKeyDown={(e) => { blockNonNumeric(e); onKeyDown?.(e); }}
      {...rest}
    />
  );
}

export default NumberInput;
